
















import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import * as api from '@/api';
import * as models from '@/api/models';
import { State, Getter, Action, Mutation, namespace } from 'vuex-class';
import AppModel from '@/store/modules/app';
import AdminSidebarMenu from './AdminSiderMenu';

/** admin banner header */
@Component({ components: { AdminSidebarMenu } })
export default class AdminSiderComponent extends Vue {
  collapsed = false;
  scrollTop: number = 0;
  element: any;
  styleObj = { position: 'fixed', top: '0' };
  get getCollapsed(): boolean {
    return AppModel.collapsed;
  }

  // 距离顶部是否大于120px
  get getScrollTop(): boolean {
    return AppModel.isScrollTop;
  }

  mounted() {
    // 监听页面大小变化
    this.element = document.querySelector('.mc-left-sider');
    // window.addEventListener('scroll', this.handleFixSider);
  }
  /** 自适应内容布局 */
  handleFixSider() {
    let top = document.documentElement.scrollTop;
    if (top <= 120) {
      top = 120 - top;
      this.element.style.top = `${top}px`;
      this.element.style.height = (window.document.body.clientHeight - top).toString() + 'px';
    } else {
      this.element.style.top = `0px`;
      this.element.style.height = '100%';
    }
    // console.log(' this.element.style.height:', top, this.element.style.height);
  }
  beforeDestroy() {
    // window.removeEventListener('resize', this.handleFixSider);
  }
}
